<!-- 结转弹出框 -->
<template>
  <div>
    <el-dialog
      title="系统提示"
      :visible.sync="isShow"
      :width="'500px'"
      :show-close="false"
      :close-on-click-modal="false"
      @open="setDate"
      class="default-dialog report-dialog default-footer-dialog"
    >
      <p class="confirm">请确认</p>
      <div class="forward-warp">
        <span>{{forwardText}}：</span>
        <el-date-picker
          v-model="date"
          type="month"
          size="small"
          style="width:130px"
          :picker-options='pickerBeginDate'
          @change="countMonth"
          placeholder="选择月">
        </el-date-picker>
      </div>
      <span v-if="forwardType == 2" style="color:#FF3049;font-size: 12px;">*反结账是违反会计规则的非正常操作，会影响历史报表数据，请慎用！</span>
      <span slot="footer">
        <accBtn type="2" width="55px" text="取消" @click="$emit('cancel')" />
        <accBtn width="55px" @click="handleConfirm" />
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  components: {},
  props: {
    displayData:{
      type:Boolean,
      default:false
    },
    isShow: {
      type: Boolean,
      default: false
    },
    forwardType: {
      type: String,
      default: ""
    }
  },
  mounted() {
  },
  watch:{
    tableData:{
      handler(val){
        let item = val.find(e=> e.other||e.bankReceipt||e.statement||e.invoice)
        if(item){
          this.showCon = false
        }else {
          this.showCon = true
        }
      },
      deep:true
    }
  },
  computed: {
    forwardText() {
      return this.forwardType == 2 ? "反结账到" : "结转到"
    },
    getAccountPeriod() {
      return this.$store.state.accountInfo.yearPeriods;
    },
    // 当前期
    accountInfo() {
      return this.$store.state.accountInfo.accountInfoData;
    }
  },
  data() {
    return {
      showCon:true,
      readConfirm:false,
      tableData:[],
      date: '',
      pickerBeginDate: {
        disabledDate: (time)=>{
          let startVal = this.getAccountPeriod.startTimeStamp;
          let endVal = this.getAccountPeriod.endTimeStamp;
          if(this.forwardType == 2) { // 反结账
            return time.getTime() < startVal || time.getTime() >= this.accountInfo.yearPeriodTimeStamp
          }else {
            // 小于这个月的最后一天
            return (time.getTime() < this.getLastDay(this.accountInfo.yearPeriodTimeStamp)) || (time.getTime() > endVal)
          }
        }
      },
    }
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm",this.date,this.tableData)
    },
    setDate() {
      this.date = this.getMonth(this.forwardType)
      this.tableData=[]
      
    },
    getMonth(type) {
      const date = String(this.accountInfo.nowYearPeriod);
      let year = date.slice(0,4); 
      let month = date.slice(4,6); 
      let year2 = year;
      let month2 = type == 2 ? parseInt(month) - 1 : parseInt(month) + 1;
      if (type == 2) {
        if (month2 == 0) {
          year2 = parseInt(year2) - 1;
          month2 = 12;
        }
        if (month2 < 10) {
          month2 = "0" + month2;
        }
      }else {
        if (month2 == 13) {
            year2 = parseInt(year2) + 1;
            month2 = 1;
        }
        if (month2 < 10) {
            month2 = "0" + month2;
        }
      }
      const Month = year2 + '-' + month2;
      return Month;
    },
    // 获取当月的最后一天
    getLastDay(time){
      let date = new Date(time)
      let y = date.getFullYear(); //获取年份
      let m = date.getMonth() + 1; //获取月份
      let d = new Date(y, m, 0).getDate(); //获取当月最后一日
      m = m < 10 ? '0' + m : m; //月份补 0
      d = d < 10 ? '0' + d : d; //日数补 0
      return new Date(String([y,m,d].join("-"))).getTime()
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .el-table__footer {
  td {
    text-align: center !important;
    background-color: #f7f7f7 !important;
  }
}
/deep/ thead th {
  padding: "6px 0";
  color: #333 !important;
  background: #f7f7f7 !important;
}
.confirm {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 15px;
}
.forward-warp {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/settleAccounts/CarryForward.vue